module.exports = __webpack_public_path__ + "static/john-ocean-cynthia-wide.9815a39b.png";